import { render } from "./UsuarioIpiranga.vue?vue&type=template&id=e9e97850&scoped=true&ts=true"
import script from "./UsuarioIpiranga.vue?vue&type=script&lang=ts"
export * from "./UsuarioIpiranga.vue?vue&type=script&lang=ts"

import "./UsuarioIpiranga.vue?vue&type=style&index=0&id=e9e97850&scoped=true&lang=css"

import exportComponent from "/Users/camp2/Devs/indicar/indicar-gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e9e97850"]])

export default __exports__